import { isApiError } from '../api/fetch/apiClient';

// Backend error responses carry an i18n KEY in the envelope's `error` field
// (e.g. "notify.mfa.too_many_attempts"). Pull it out of an ApiError so the UI can
// translate the real reason, falling back to a caller-supplied generic key when
// the error isn't an ApiError or has no key (network failure, 5xx, etc.).
// Some endpoints instead carry a plain-string message in `resp` (no i18n key
// available) — fall back to that before giving up to the caller's fallback.
export const apiErrorKey = (err: unknown, fallback: string): string => {
  if (isApiError(err)) {
    const body = err.body as { error?: string; resp?: string } | undefined;
    if (typeof body?.error === 'string') return body.error;
    if (typeof body?.resp === 'string') return body.resp;
  }
  return fallback;
};
